import $ from 'jquery';


class Accessibility {
    maxFontLevel = 5;

    defaultSettings = {
        fontLevel: 1,
        contrastMode: 0,
    };

    constructor() {
        this.$tool = $('.accessibility');
        this.$fontButtons = this.$tool.find('.accessibility__control-button');
        this.$contrastToggle = this.$tool.find('.accessibility__contrast-toggle');
        this.$fontLevelOutput = this.$tool.find('.accessibility__font-level');
        this.$toolToggle = this.$tool.find('.accessibility__toggle');
        this.$toolClose = this.$tool.find('.accessibility__close');
        this.$toolContent = this.$tool.find('.accessibility__content');
        this.$resetButton = this.$tool.find('.accessibility__reset');

        this.settings = JSON.parse(localStorage.getItem("accessibilitySettings"));

        if(this.settings === null) {
            this.settings = this.defaultSettings;
            this.$tool.addClass('accessibility--show-tooltip');

            setTimeout(() => {
                this.$tool.removeClass('accessibility--show-tooltip');
            }, 5000);
        }

        this.$fontButtons.on('click', this.adjustFontLevel.bind(this));
        this.$contrastToggle.on('click', this.toggleContrastMode.bind(this));

        this.$toolToggle.on('click', e => {e.preventDefault()});
        this.$toolToggle.on('click', this.openTool.bind(this));

        this.$toolClose.on('click', e => {e.preventDefault()});
        this.$toolClose.on('click', this.closeTool.bind(this));

        this.$resetButton.on('click', this.resetSettings.bind(this));

        this.$toolContent.find('a,button').attr('tabindex', -1);

        this.bindKeydown();
        this.updateSettings();

        this.fixSvgTabindex()
    }

    fixSvgTabindex() {
        let $targetSvgs = $('svg:not([tabindex])');
        $targetSvgs.attr('tabindex', -1);
        $targetSvgs.find('*').attr('tabindex', -1);
    }

    updateSettings() {
        this.validateFontLevel();

        $('html').attr('data-font-level', this.settings.fontLevel);
        $('html').attr('data-contrast-mode', this.settings.contrastMode);
        this.$fontLevelOutput.text(this.settings.fontLevel);

        if(this.settings.contrastMode === 1) {
            $('body').addClass('contrast-mode');
        } else {
            $('body').removeClass('contrast-mode');
        }

        localStorage.setItem("accessibilitySettings", JSON.stringify(this.settings));

        if(JSON.stringify(this.settings) !== JSON.stringify(this.defaultSettings)) {
            this.$tool.addClass('accessibility--active');
        } else {
            this.$tool.removeClass('accessibility--active');
        }
    }

    resetSettings(e) {
        e.preventDefault();
        this.settings = {...this.defaultSettings};
        this.updateSettings();
    }

    toggleTool() {
        if(this.$tool.hasClass('accessibility--open')) {
            this.closeTool();
        } else {
            this.openTool();
        }
    }

    openTool() {
        this.$tool.addClass('accessibility--open');
        this.$toolContent.find('a,button').attr('tabindex', 0);
        this.$toolToggle.attr('tabindex', -1);
        this.$toolClose.focus();
    }

    closeTool() {
        this.$tool.removeClass('accessibility--open');
        this.$toolContent.find('a,button').attr('tabindex', 1);
        this.$toolToggle.attr('tabindex', 0);
        this.$toolToggle.focus();
    }

    adjustFontLevel(e) {
        let $button = $(e.currentTarget);
        e.preventDefault();

        if($button.hasClass('accessibility__font-decrease')) {
            this.settings.fontLevel--;
        }

        if($button.hasClass('accessibility__font-increase')) {
            this.settings.fontLevel++;
        }

        this.updateSettings();
    }

    validateFontLevel() {
        if(this.settings.fontLevel < 1) {
            this.settings.fontLevel = 1;
        }

        if(this.settings.fontLevel > this.maxFontLevel) {
            this.settings.fontLevel = this.maxFontLevel;
        }
    }

    toggleContrastMode(e) {
        e.preventDefault();

        if(this.settings.contrastMode === 0) {
            this.settings.contrastMode = 1;
        } else {
            this.settings.contrastMode = 0;
        }

        this.updateSettings()
    }

    bindKeydown() {
        $(document).on('keydown', (e) => {
            if(e.keyCode === 27) {
                this.closeTool();
            }

            if(e.altKey) {
                switch (e.keyCode) {
                    case 107:
                    case 171:
                    case 187:
                        this.settings.fontLevel++;
                        this.updateSettings();
                        break;
                    case 109:
                    case 173:
                    case 189:
                        this.settings.fontLevel--;
                        this.updateSettings();
                        break;
                    case 75:
                        this.toggleContrastMode(e);
                        break;
                    case 49:
                        this.toggleTool();
                        break;
                }
            }
        });
    }

}

new Accessibility();
